/* dace. – Logo im Hero: Nach dem Laden zeichnet sich die fehlende Hälfte ein (Notizbuch + App).
   Klick oder Tippen lässt das Pik hüpfen. Sehr leicht, nur CSS-Klassen. */
(() => {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll(".moon-hero").forEach(m => {
    if (reduce) { m.classList.add("on"); return; }
    const show = () => m.classList.add("on");
    setTimeout(() => m.classList.add("ready"), 1400);
    const t = setTimeout(show, 1500);
    addEventListener("scroll", () => { if (scrollY > 40) { clearTimeout(t); show(); } }, { passive: true, once: true });
    m.addEventListener("click", () => {
      show();
      m.classList.remove("hop"); void m.offsetWidth; m.classList.add("hop");
    });
    m.addEventListener("animationend", e => { if (e.animationName === "pip-hop") m.classList.remove("hop"); });
  });
})();
